document.addEventListener('DOMContentLoaded', () => {
    const allElements = document.querySelectorAll('.fade-in-section, .fade-in-section-fast');

    const observer = new IntersectionObserver(entries => {
        entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
                const delay = index * 50; // Adjust the delay as needed

                setTimeout(() => {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }, delay);
            }
        });
    }, { threshold: 0.2 });

    allElements.forEach(element => {
        observer.observe(element);
    });
    //
    // allElements.forEach(element => {
    //     if (element.getBoundingClientRect().top < window.innerHeight) {
    //         element.classList.add('is-visible');
    //         observer.unobserve(element);
    //     }
    // });

});

//# sourceMappingURL=animate-words.js.map
